import {Dispatch, Fragment, useState} from "react";
import {Box, Card, CardContent, Grid, useMediaQuery, useTheme} from '@mui/material';
import {Typography} from '@mui/material';
import React from 'react';
import Button from "@mui/material/Button";
import ScoreCardDialog from "../../dialogs/scoreCardDialog/scoreCardDialog";
import {recordScore} from "../../../interfaces/recordScore";
import {useAccelerator} from "../../../hooks/acceleratorDataProvider";

const RecordAndTrackHeader = ({recordDispatcher, date, setDate, onSubmitClick}: {
    recordDispatcher: Dispatch<{ type: string, payload: any }>,
    date: [Date, Date],
    setDate: (Array: [Date, Date]) => void,
    onSubmitClick?: () => void,
}) => {
    const [showScoreBoardDialog, setShowScoreBoardDialog] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const isLessThan900px = useMediaQuery('(max-width: 900px)');
    const {averageScore, setAverageScore} = useAccelerator();

    const addRecordToTable = (response: any, scoreboard: recordScore) => {
        // Update averageScore in context (used in both recordAndTrackHeader and statsPanel)
        if (response && typeof response.avg === 'number') {
            setAverageScore(response.avg);
        }
        let scoreDate = new Date(scoreboard.record_date.toString());
        const start = new Date(date[0]);
        const end = new Date(date[1]);
        if (scoreDate < start || scoreDate > end) {
            setDate([new Date(new Date().getFullYear() - 10, 0, 1), new Date()]);
        } else {
            recordDispatcher({
                type: "add",
                payload: {...scoreboard, record_id: response.record_id}
            })
        }
    }

    return (
        <Fragment>

            <Grid container spacing={0} justifyContent="space-between" alignItems="flex-end"
                  sx={{
                      marginTop: 0, '&>.MuiGrid-item': {pt: 0}, flexDirection: {xs: "row", md: "row"},
                      alignItems: {xs: "stretch", md: "flex-start"}
                  }}>
                <Grid item xs={12} md={7} sx={{marginTop: "auto", marginBottom: "auto"}}>
                    <Typography sx={{
                        fontWeight: 350,
                        fontSize: {xs: 20, md: 36},
                        padding: {xs: "2px 0", md: 0},
                        fontFamily: "'Repro GT Super Text', sans-serif",
                        letterSpacing: isMobile ? "0px" : "-1px"
                    }}>
                        How to train, practice and play like a scratch golfer</Typography>
                </Grid>
                <Grid item xs={12} md={5} sx={{paddingTop: 0}}>
                    <Box sx={{display: 'flex', justifyContent: {xs: 'stretch', md: 'flex-start'}}}>
                        <Typography
                            sx={{fontSize: 14, lineHeight: "122%", padding: {xs: "20px 0", md: "10px 0"}
                            , fontFamily: "'Repro', sans-serif", color: isMobile ? "#7B726C" : "#182026"}}>
                            Submit Scorecard to Measure Your Scratch Golf Game
                            across all our
                            training {!isMobile ? <br/> : ""} accelerators
                            to track improvement.</Typography>
                    </Box>
                    <Card variant="outlined"  
                        sx={{borderRadius: "10px", 
                            border: " 2px solid #E5E5E5", 
                            maxWidth: "568px",
                            margin: {xs: "0", md: 0}}}>
                        <CardContent sx={{ padding: "16px 10px", '&:last-child': {pb: 2}}}>
                            <Box sx={{display: {xs: "block", md: "flex"}, justifyContent: 'flex-end'}}>
                                <Box sx={{display: "flex"}}>
                                    <Box component="img"
                                         src="https://www.performancegolf.com/wp-content/uploads/2025/12/SC_Badge_gray.png"
                                         alt="badge"
                                         sx={{margin: {xs: "auto 15px auto 0", md: "auto 20px auto 10px"}}}></Box>
                                    <Typography
                                        sx={{
                                            fontSize: {xs: 17, md: 17},
                                            fontWeight: 500,
                                            lineHeight: {xs: "17px", md: "22px"},
                                            margin: "auto 0",
                                            textTransform: "uppercase",
                                            fontFamily: "'Repro', sans-serif",
                                        }}>
                                        Scratch Club <br/>Average Score</Typography>
                                    <Typography
                                        sx={{
                                            fontSize: {xs: "40px", md: "40px"},
                                            lineHeight: {xs: "40px", md: "50px"},
                                            fontWeight: {xs: "900", md: "900"},
                                            color: "#1D1A1A",
                                            padding: {xs: 0, md: "0 12px"},
                                            marginTop: "auto",
                                            marginBottom: "auto",
                                            marginLeft: {xs: "auto", md: 0},
                                            marginRight: isMobile ? "25px" : 0,
                                            fontFamily: "'Nunito Sans', sans-serif",
                                        }}
                                    >{averageScore}</Typography>
                                </Box>
                                <Box sx={{padding: 0, margin: "auto"}}>
                                    <Button variant="contained"
                                            onClick={() => {
                                                if ((isMobile || isLessThan900px) && onSubmitClick) {
                                                    onSubmitClick();
                                                } else {
                                                    setShowScoreBoardDialog(true);
                                                }
                                            }}
                                            fullWidth={isMobile}
                                            sx={{
                                                fontSize: "16px",
                                                lineHeight: "20px",
                                                fontWeight: 700,
                                                backgroundColor: "#FD3300",
                                                padding: "10px 30px",
                                                marginTop: {xs: "20px", md: "auto"},
                                                marginBottom: "auto",
                                                borderRadius: "100px",
                                                textTransform: "capitalize",
                                                "&:hover": {
                                                    backgroundColor: "#E02B00"
                                                },
                                                fontFamily: "'Repro', sans-serif",
                                            }}
                                    >
                                        Submit scorecard
                                    </Button>
                                </Box>
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>

            <ScoreCardDialog show={showScoreBoardDialog} setShow={setShowScoreBoardDialog}
                             callback={addRecordToTable}/>
        </Fragment>
    );
};

export default RecordAndTrackHeader;